// Whitespaces wordmark logo — "The Unclaimed Cell": a sixteen-cell audience grid, one segment still untapped.
export const Logo = ({ className = "", onClick, testId = "whitespaces-logo" }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      className={`group flex items-center ${className}`}
      aria-label="Whitespaces home"
    >
      <img
        src="/brand/whitespaces-logo-full.png"
        alt="Whitespaces"
        className="h-full w-auto object-contain transition-opacity duration-300 group-hover:opacity-80"
      />
    </button>
  );
};

export default Logo;
